import { useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import ToggleButton from 'react-bootstrap/ToggleButton';
import axios from 'axios';
import { Input } from "../models/input";
import parse from 'html-react-parser';
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactLoading from 'react-loading';
import AdminStore from "../stores/adminStore";
import { useStore } from "../stores/store";
import { observer } from "mobx-react-lite";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { textSpanIntersectsWithTextSpan } from "typescript";
declare global {
    interface Window {
        gtagSendEvent: (params: any) => void;
    }
}

export default observer(function Main() {

    const [input, setInput] = useState("");
    const [inputPrompt, setInputPrompt] = useState("Fix grammatical errors and typos in the text");
    const [output, setOutput] = useState("");
    const [inputVis, setInputVis] = useState("block");
    const [outputVis, setOutputVis] = useState('none');
    const [checked, setChecked] = useState(false);
    const [copyChecked, setCopyChecked] = useState(false);
    const [basicOutput, setBasicOutput] = useState('');
    const [colorOutput, setColorOutput] = useState('');
    const [copyOutput, setCopyOutput] = useState('');
    const [loading, setLoading] = useState(false);
    const [first, setFirst] = useState(true);

    const { commonStore, userStore, adminStore } = useStore();


    const baseUrl = process.env.REACT_APP_API_URL + 'input';

    useEffect(() => {
        adminStore.getAdminPrompts();

    }, [adminStore])


    function handleSubmit() {
        window.gtagSendEvent('');
        const request = {} as Input;
        request.text = input;
        request.prompt = inputPrompt;
        setLoading(true);

        var response = axios.post(baseUrl!, request).then(response => {
            handlerOutput(response.data.data.colorOutput, response.data.data.outputText, response.data.data.copyText);
            setLoading(false);
        });

    }

    function handlerOutput(output: string, outputText: string, copyText: string) {
        setInputVis('none');
        setOutputVis('block');
        setOutput(output)
        setBasicOutput(outputText);
        setColorOutput(output);
        setCopyOutput(copyText);
        setChecked(true);
    }

    function handleClear() {
        setOutput('');
        setInput('');
        setInputPrompt('');
        setInputVis('block');
        setOutputVis('none');
    }

    function handlePromptClear() {
        setInputPrompt('');
    }

    function handlePromptButton(event: HTMLElement) {

        if (first) {
            setInputPrompt(inputPrompt);
            setFirst(false);
        }

        if (!first && inputPrompt.length > 0) {
            setInputPrompt(inputPrompt + ' and ' + event.innerText.charAt(0).toLowerCase() + event.innerText.slice(1).toLowerCase())
        }
        else {
            setInputPrompt(event.innerText.trimStart());
        }
    }

    function handleShowChanges(event: React.ChangeEvent<HTMLInputElement>) {
        setChecked(event.currentTarget.checked);


        if (output.length > 0 && basicOutput.length > 0) {
            if (event.currentTarget.checked) {
                setOutput(colorOutput);
            }
            else {
                setOutput(basicOutput);
            }
        }

    }

    function handleCopy(target: HTMLInputElement) {


        setCopyChecked(target.checked);

        if (target.checked) {
            target.nextElementSibling!.textContent = 'Copied';
        }
        else {
            target.nextElementSibling!.textContent = 'Copy';
        }


        if (basicOutput.length > 0) {
            navigator.clipboard.writeText(copyOutput);
        }

    }

    return (
        <>
            <Container>
                <HelmetProvider>
                    <Helmet>
                        <title>Free AI-Powered Writing Assistant</title>
                        <meta name="description" content="Transform your writing instantly with EnglishEdit.AI – the free, no-sign-up, no hassle English editing tool powered by OpenAI. Achieve perfection in your text with a single click, leveraging the latest in AI technology to enhance grammar, clarity, and style effortlessly."></meta>
                    </Helmet>
                </HelmetProvider>
                <Row>
                    <Col>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                        <h1>Free Writing Tool</h1>
                    </Col>
                    <Col>
                    </Col>

                </Row>
                <Row style={{ marginTop: "2em" }}>
                    <Col lg={1}></Col>
                    <Col lg={10}> <h5 style={{ textAlign: "center" }}>Use AI technology to ensure your writing is mistake-free. Choose a prompt or a combination of prompts and then paste your text below to use natural language processing to improve your writing.</h5></Col>
                    <Col></Col>
                </Row>
                <Row style={{ marginTop: "3em" }}>
                    <Col lg={2}></Col>
                    <Col lg={8}>
                        <h5 style={{ textAlign: "left" }}>How would you like your text edited?</h5>
                    </Col>
                    <Col></Col>
                </Row>
                {adminStore.adminPrompts &&
                    adminStore.adminPrompts.map((p, index) => (
                        // Check if the index is even to start a new row
                        index % 2 === 0 && (
                            <Row className="mt-3" key={index}>
                                <Col lg={2}></Col>
                                <Col lg={4}>
                                    <Button
                                        onClick={(e) => handlePromptButton(e.target as HTMLElement)}
                                        variant="light" >
                                        <FontAwesomeIcon icon={faPlus} className="me-2" />
                                        {p.promptText}
                                    </Button>
                                </Col>
                                {/* Render the second element in the pair if available */}
                                {adminStore.adminPrompts[index + 1] && (
                                    <Col lg={4}>
                                        <Button
                                            onClick={(e) => handlePromptButton(e.target as HTMLElement)}
                                            variant="light"
                                        >
                                            <FontAwesomeIcon icon={faPlus} className="me-2" />
                                            {adminStore.adminPrompts[index + 1].promptText}
                                        </Button>
                                    </Col>
                                )}
                            </Row>
                        )
                    ))}

                <Row style={{ marginTop: "2em" }}>
                    <Col lg={2}></Col>
                    <Col lg={8}>
                        <Row>

                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginTop: "2em", textAlign: 'right', width: '104%' }}>
                    <Col lg={3} className="mt-1">
                        <span>How would you like your text edited?</span>
                    </Col>
                    <Col lg={7}>
                        <Form.Control value={inputPrompt} onChange={(e) => setInputPrompt(e.target.value)} style={{ display: 'inline-block', width: "100%" }} type="text" id="prompt" />
                    </Col>
                    <Col lg={2} style={{ textAlign: 'left' }}><Button onClick={handlePromptClear} variant="warning">Reset Prompt</Button></Col>
                </Row>

                <Row style={{ marginLeft: '8rem', marginTop: "3em" }}>

                    {loading ? (
                        <>
                            <Col lg={5}></Col>
                            <Col lg={3} style={{ textAlign: 'center', paddingTop: '3rem' }}>
                                <ReactLoading type='spin' color='#00FF00' height='5rem' width='5rem' />
                            </Col>
                            <Col lg={4}></Col>
                        </>
                    ) :
                        (
                            <Col lg={10}>
                                <Form.Control value={input} id="input-id" onChange={(e) => setInput(e.target.value)} as="textarea" placeholder="Enter your text here" style={{ display: inputVis, height: '30rem', fontSize: 'x-large' }} />
                                <p style={{ overflow: 'auto', display: outputVis, height: '30rem', marginBlockEnd: "0", fontSize: 'x-large' }} className='form-control'>{parse(output)}</p>
                            </Col>
                        )
                    }

                    <Col></Col>
                </Row>
                <Row style={{ marginTop: '3em' }}>
                    <Col lg={4}></Col>
                    <Col lg={4} style={{ textAlign: 'center' }}><Button style={{ width: '50%' }} onClick={handleSubmit} variant="success">Edit My Text</Button></Col>

                </Row>
                <Row style={{ marginTop: "3em" }}>
                    <Col lg={3}></Col>
                    <Col lg={2} style={{ textAlign: 'center' }}>
                        <Form.Check reverse label='Show Changes' className="mb-2 mt-2" id="toggle-check" type="checkbox"
                            disabled={output.length == 0} checked={checked} value="1" onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleShowChanges(e)} />


                    </Col>
                    <Col lg={2} style={{ textAlign: 'center' }}><ToggleButton className="mb-2" id="toggle-check2" type="checkbox"
                        variant="outline-secondary" checked={copyChecked} value="1" onChange={(e) => handleCopy(e.currentTarget)}>
                        Copy
                    </ToggleButton></Col>
                    <Col lg={2} style={{ textAlign: 'center' }}><Button onClick={handleClear} variant="warning">Clear</Button></Col>
                    <Col lg={2}></Col>
                </Row>
                <Row style={{ height: "2em" }}>
                </Row>


                <Row style={{ marginTop: '2em' }}>
                    <Col></Col>
                </Row>
            </Container>
        </>
    )
})